module.exports = () => next => action => {
  action.type === "LOCATION"
    ? window.location.replace(action.payload)
    : next(action);
};



// WEBPACK FOOTER //
// ../shared/optilit-redux-middleware/location.js